import React from 'react';
import { IconStarFilled, Inline, Radio, Stack, Text } from '@treatwell/ui';
import { VenueListingSpecificationOutput } from 'js/model/rainbow/browse-page/VenueListingSpecificationOutput';
import { useTranslation } from 'react-i18next';
import { Filter } from '../Filters/useFilters';

type Ratings = [
  undefined,
  ...NonNullable<VenueListingSpecificationOutput['minReviewRating']>[],
];

const RATINGS: Ratings = [undefined, 5, 4, 3, 2, 1];

export const isRatingFilterActive = ({
  minReviewRating,
}: VenueListingSpecificationOutput): boolean => minReviewRating !== undefined;

export const RatingFilter = ({
  id,
  checked,
  onChange,
}: {
  id: Filter['id'];
  checked: (rating: Ratings[number]) => boolean;
  onChange: (rating: Ratings[number]) => void;
}) => {
  const { t } = useTranslation();

  return (
    <Stack as="ul" space="md">
      {RATINGS.map((rating) => {
        const key = `rating-${rating}`;

        return (
          <li key={key}>
            <Inline justify="between">
              <Text as="label" htmlFor={key}>
                {rating === undefined ? (
                  t('browsePage.filter.rating.defaultValue')
                ) : (
                  <Inline space="xs">
                    {t('browsePage.filter.rating.value', {
                      count: rating,
                    })}
                    {Array.from(
                      { length: rating },
                      (_, index) => rating - index
                    ).map((star) => (
                      <IconStarFilled key={`star-${star}`} size={16} />
                    ))}
                  </Inline>
                )}
              </Text>
              <Radio
                id={key}
                name={id}
                value={`${rating}`}
                checked={checked(rating)}
                onChange={() => {
                  onChange(rating);
                }}
              />
            </Inline>
          </li>
        );
      })}
    </Stack>
  );
};
